// @ts-nocheck

import PropTypes from 'prop-types';
import { Dropdown } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import map from 'lodash/map';
import filter from 'lodash/filter';
// @ts-nocheck

import Icon from '@plone/volto/components/theme/Icon/Icon';
import { contentsMessages as messages } from '../messages/contentsMessages';
import { checkboxCheckedSVG, checkboxUncheckedSVG, moreSVG } from '../icons';

const ColumnSelectDropdown = ({ index, onSelectIndex }) => {
  const intl = useIntl();

  return (
    <Dropdown
      item
      upward={false}
      icon={<Icon name={moreSVG} size="24px" color="#826a6a" />}
      className="right floating selectIndex"
    >
      <Dropdown.Menu className="left">
        <Dropdown.Header content={intl.formatMessage(messages.selectColumns)} />
        <Dropdown.Menu scrolling>
          {map(
            filter(index.order, (idx) => idx !== 'sortable_title'),
            (idx) => (
              <Dropdown.Item
                key={idx}
                value={idx}
                onClick={onSelectIndex}
                className="iconAlign"
              >
                {index.values[idx].selected ? (
                  <Icon
                    name={checkboxCheckedSVG}
                    size="24px"
                    color="#007eb1"
                    className={index.values[idx].label}
                  />
                ) : (
                  <Icon
                    name={checkboxUncheckedSVG}
                    className={index.values[idx].label}
                    size="24px"
                  />
                )}
                <span>
                  {' '}
                  {intl.formatMessage({
                    id: index.values[idx].label,
                    defaultMessage: index.values[idx].label,
                  })}
                </span>
              </Dropdown.Item>
            ),
          )}
        </Dropdown.Menu>
      </Dropdown.Menu>
    </Dropdown>
  );
};

ColumnSelectDropdown.propTypes = {
  index: PropTypes.shape({
    order: PropTypes.arrayOf(PropTypes.string).isRequired,
    values: PropTypes.objectOf(
      PropTypes.shape({
        selected: PropTypes.bool,
        label: PropTypes.string,
      }),
    ).isRequired,
  }).isRequired,
  onSelectIndex: PropTypes.func.isRequired,
};

export default ColumnSelectDropdown;
